// This function will be used to modify the way that Prismic's Rich Text is rendered
// Ref: https://prismic.io/docs/reactjs/beyond-the-api/html-serializer

var linkResolver = require('./linkResolver');
var prismicH = require( '@prismicio/helpers' );
const Element = prismicH.Element;

const htmlSerializer = ( type, element, content, children ) => {
    switch( type ) {
        case Element.heading2:
            return `<h2 class="heading text-xl article-heading">${children}</h2>`;

        case Element.heading3:
            return `<h3 class="heading text-lg article-heading">${children}</h3>`;

        case Element.heading4:
            return `<h4 class="text-md text-bold article-heading">${children}</h4>`;

        case Element.heading5:
            return `<h5 class="text-md text-normal article-heading">${children}</h5>`;

        case Element.heading6:
            return `<h6 class="text-md text-normal article-heading">${children}</h6>`;

        case Element.paragraph:
            return children && children.length > 0 ? `<p class="paragraph">${children}</p>` : '';

        case Element.hyperlink:
            var target = element.data.target ? `target="${element.data.target}" rel="noopener noreferrer"` : ``;
            var linkUrl = prismicH.asLink(element.data, linkResolver);

            return `<a class="button-text" ${target} href="${linkUrl}">${children}</a>`;

        case Element.list:
            return `<ul class="list-bullet">${children}</ul>`;

        case Element.oList:
            return `<ol class="list-ordered">${children}</ol>`;

        case Element.image:
            var imgLinkUrl = element.linkTo ? prismicH.asLink(element.linkTo, linkResolver) : null;
            var linkTarget = element.linkTo && element.linkTo.target ? `target="${element.linkTo.target}" rel="noopener"` : ``;
            var wrapperClassList = [element.label || '', 'article-img'];
            var img = `<img src="${element.url}" alt="${element.alt || ''}" copyright="${element.copyright || ''}">`;

            return `
                  <div class="${wrapperClassList.join(' ')}">
                    ${imgLinkUrl ? `<a ${linkTarget} href="${imgLinkUrl}">${img}</a>` : img}
                  </div>
                `;

        // TODO: implement embedding as separate slice
        // case Element.embed:
        //     return `
        //           <div data-oembed="${element.oembed.embed_url}"
        //             data-oembed-type="${element.oembed.type}"
        //             data-oembed-provider="${element.oembed.provider_name}"
        //           >
        //             ${element.oembed.html}
        //           </div>
        //         `;

        default:
            return null;
    }
};

module.exports = htmlSerializer;
